// extracted by mini-css-extract-plugin
module.exports = {"textLink":"mobile_user-info_textLink___FPCm","link":"mobile_user-info_link__xXU_m","name":"mobile_user-info_name__YPU_z"};